/* eslint-disable no-unused-vars */
import { createAPIHandler, useOFetchRaw } from "@/plugins/ofetch";

const _AuthAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").login>}  */
  login: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/login`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").resetPassword>}  */
  resetPassword: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/reset-password`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").signUp>}  */
  signUp: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/sign-up`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").authByOrgIdAndEmail>}  */
  authByOrgIdAndEmail: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/auth-by-org-id-and-email`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").authByOrganizerIdAndEmail>}  */
  authByOrganizerIdAndEmail: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/auth-by-organizer-id-and-email`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").authByRoleAndEmail>}  */
  authByRoleAndEmail: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/auth-by-id-role-and-email`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").checkOrganizationId>}  */
  checkOrganizationId: createAPIHandler(
    ([organizationId, query = undefined]) => [
      `/n/api/public/check-org-id/${encodeURIComponent(organizationId)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").checkOrganizationFundraisingTeamId>}  */
  checkOrganizationFundraisingTeamId: createAPIHandler(
    ([fundraisingTeamId, query = undefined]) => [
      `/n/api/public/check-org-fundraising-team-id/${encodeURIComponent(fundraisingTeamId)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").checkVerificationCode>}  */
  checkVerificationCode: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/check-verification-code`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").sendVerificationCode>}  */
  sendVerificationCode: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/send-verification-code`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").updatePersonalSettings>}  */
  updatePersonalSettings: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/personal-settings`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/auth.js").logout>}  */
  logout: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/logout`,
      { method: "POST", body, query }
    ]
  ),
};
export { _AuthAPI as AuthAPI };
const _EventParticipationsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/event-participations.js").getEventParticipationByEventAndOrganization>}  */
  getEventParticipationByEventAndOrganization: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/event-participations/search_by_event_and_organization`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/event-participations.js").getFundraisingEventParticipationByEventAndOrganization>}  */
  getFundraisingEventParticipationByEventAndOrganization: createAPIHandler(
    ([organization_id, event_id, query = undefined]) => [
      `/n/api/public/fundraising/${encodeURIComponent(organization_id)}/${encodeURIComponent(event_id)}/event-participations`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/event-participations.js").getEventParticipationTeams>}  */
  getEventParticipationTeams: createAPIHandler(
    ([event_participation_id, query = undefined]) => [
      `/n/api/public/event-participations/${encodeURIComponent(event_participation_id)}/teams`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/event-participations.js").getTeam>}  */
  getTeam: createAPIHandler(
    ([event_participation_id, team_id, query = undefined]) => [
      `/n/api/public/event-participations/${encodeURIComponent(event_participation_id)}/teams/${encodeURIComponent(team_id)}`,
      { method: "GET", query }
    ]
  ),
};
export { _EventParticipationsAPI as EventParticipationsAPI };
const _EventsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEvent>}  */
  getEvent: createAPIHandler(
    ([event_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventByEventIdOrFundraisingEventId>}  */
  getEventByEventIdOrFundraisingEventId: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/events/find-by-event-id-or-fundraising-event-id`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getSalesCategories>}  */
  getSalesCategories: createAPIHandler(
    ([event_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/sales-categories`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventPaymentMethods>}  */
  getEventPaymentMethods: createAPIHandler(
    ([event_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/payment-methods`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getEventRegisterItems>}  */
  getEventRegisterItems: createAPIHandler(
    ([event_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/register-items`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").findEventDiscountCode>}  */
  findEventDiscountCode: createAPIHandler(
    ([event_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/discount-codes`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").updateRegistration>}  */
  updateRegistration: createAPIHandler(
    ([event_id, unique_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/registration/${encodeURIComponent(unique_id)}`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").findSalesDiscountCode>}  */
  findSalesDiscountCode: createAPIHandler(
    ([event_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/sales-discount-codes`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").submitPPSData>}  */
  submitPPSData: createAPIHandler(
    ([event_id, unique_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/registration/${encodeURIComponent(unique_id)}/pps-data`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").shareTicket>}  */
  shareTicket: createAPIHandler(
    ([event_id, registration_id, register_order_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/registration/${encodeURIComponent(registration_id)}/share-ticket/${encodeURIComponent(register_order_id)}`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").getTaxReceiptStatus>}  */
  getTaxReceiptStatus: createAPIHandler(
    ([event_id, order_id, registration_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/registrations/${encodeURIComponent(order_id)}/${encodeURIComponent(registration_id)}/tax-receipt-status`,
      { method: "GET", query }
    ]
  ),
  /** @type {DownloadAPI<import("../../../../backend/api/public/events.js").getTaxReceipt>}  */
  getTaxReceipt: async function(event_id, order_id, registration_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/events/${encodeURIComponent(event_id)}/registrations/${encodeURIComponent(order_id)}/${encodeURIComponent(registration_id)}/tax-receipt`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `tax-receipt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").canAdditionalOrder>}  */
  canAdditionalOrder: createAPIHandler(
    ([event_id, unique_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/register-order/${encodeURIComponent(unique_id)}/can-additional-order`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").updateRegisterOrderShippingInfos>}  */
  updateRegisterOrderShippingInfos: createAPIHandler(
    ([event_id, order_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/register-order/${encodeURIComponent(order_id)}`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").updatePPSOptOut>}  */
  updatePPSOptOut: createAPIHandler(
    ([event_id, unique_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/registration/${encodeURIComponent(unique_id)}/pps-opt-out`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/events.js").revertPPSOptOut>}  */
  revertPPSOptOut: createAPIHandler(
    ([event_id, unique_id, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/registration/${encodeURIComponent(unique_id)}/pps-opt-out`,
      { method: "DELETE", query }
    ]
  ),
};
export { _EventsAPI as EventsAPI };
const _FundraisingAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/fundraising.js").getFundraisingCategories>}  */
  getFundraisingCategories: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/fundraising/categories`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/fundraising.js").getFundraisingCharities>}  */
  getFundraisingCharities: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/fundraising/charities`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/fundraising.js").getFundraisingCharity>}  */
  getFundraisingCharity: createAPIHandler(
    ([fundraising_charity_id, query = undefined]) => [
      `/n/api/public/fundraising/charities/${encodeURIComponent(fundraising_charity_id)}`,
      { method: "GET", query }
    ]
  ),
};
export { _FundraisingAPI as FundraisingAPI };
const _HelpChatAttachmentsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/help-chat-attachments.js").uploadHelpChatAttachment>}  */
  uploadHelpChatAttachment: createAPIHandler(
    ([file, body = undefined, query = undefined]) => {
      const formData = new FormData();
      for (const key in body) formData.append(key, body[key]);
      formData.append("file", file);
      return [
        `/n/api/public/help-chat-attachments`,
        { method: "POST", query, body: formData }
      ];
    }
  ),
};
export { _HelpChatAttachmentsAPI as HelpChatAttachmentsAPI };
const _InvoiceAPI = {
  /** @type {DownloadAPI<import("../../../../backend/api/public/invoice.js").getInvoice>}  */
  getInvoice: async function(id, zoho_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/invoice/${encodeURIComponent(id)}/${encodeURIComponent(zoho_id)}`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `${encodeURIComponent(zoho_id)}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
  /** @type {FetchAPI<import("../../../../backend/api/public/invoice.js").requestInvoices>}  */
  requestInvoices: createAPIHandler(
    ([event_participation_id, body = {}, query = undefined]) => [
      `/n/api/public/event-participations/${encodeURIComponent(event_participation_id)}/request-invoices`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/invoice.js").updateBillingDetails>}  */
  updateBillingDetails: createAPIHandler(
    ([event_participation_id, body = {}, query = undefined]) => [
      `/n/api/public/event-participations/${encodeURIComponent(event_participation_id)}/update-billing-details`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {DownloadAPI<import("../../../../backend/api/public/invoice.js").downloadOrdersSummary>}  */
  downloadOrdersSummary: async function(event_participation_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/event-participations/${encodeURIComponent(event_participation_id)}/orders-summary`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `orders-summary`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
};
export { _InvoiceAPI as InvoiceAPI };
const _MeAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/me.js").getMe>}  */
  getMe: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/me`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/me.js").updateMe>}  */
  updateMe: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/me`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/me.js").getMeByCookie>}  */
  getMeByCookie: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/me-by-cookie`,
      { method: "GET", query }
    ]
  ),
};
export { _MeAPI as MeAPI };
const _OrganizationsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/organizations.js").getOrganization>}  */
  getOrganization: createAPIHandler(
    ([id, query = undefined]) => [
      `/n/api/public/organizations/${encodeURIComponent(id)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/organizations.js").createOrganization>}  */
  createOrganization: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/organizations`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/organizations.js").createOrganizationFromFundraising>}  */
  createOrganizationFromFundraising: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/organizations-from-fundraising`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/organizations.js").getSalesOrderId>}  */
  getSalesOrderId: createAPIHandler(
    ([organization_id, event_id, sales_order_id, query = undefined]) => [
      `/n/api/public/organizations/${encodeURIComponent(organization_id)}/event/${encodeURIComponent(event_id)}/sales-orders/${encodeURIComponent(sales_order_id)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/organizations.js").createOrganizationNotification>}  */
  createOrganizationNotification: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/new-organization-notification`,
      { method: "POST", body, query }
    ]
  ),
};
export { _OrganizationsAPI as OrganizationsAPI };
const _ParticipantInvitesAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/participant-invites.js").getParticipantInvite>}  */
  getParticipantInvite: createAPIHandler(
    ([token, query = undefined]) => [
      `/n/api/public/participant-invites/${encodeURIComponent(token)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/participant-invites.js").declineParticipantInvite>}  */
  declineParticipantInvite: createAPIHandler(
    ([token, body = {}, query = undefined]) => [
      `/n/api/public/participant-invites/${encodeURIComponent(token)}/decline`,
      { method: "POST", body, query }
    ]
  ),
};
export { _ParticipantInvitesAPI as ParticipantInvitesAPI };
const _ParticipantRequestFormAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/participant-request-form.js").getParticipantRequestForm>}  */
  getParticipantRequestForm: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/participant-request-form`,
      { method: "GET", query }
    ]
  ),
};
export { _ParticipantRequestFormAPI as ParticipantRequestFormAPI };
const _PaymentAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/payment.js").handlePaymentWebhooks>}  */
  handlePaymentWebhooks: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/payment/webhooks`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/payment.js").handleTaxReceiptWebhook>}  */
  handleTaxReceiptWebhook: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/payment/webhooks/tax-receipt`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/payment.js").getPaymentReturn>}  */
  getPaymentReturn: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/payment/return`,
      { method: "GET", query }
    ]
  ),
};
export { _PaymentAPI as PaymentAPI };
const _PpsAttachmentsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/pps-attachments.js").uploadPpsAttachment>}  */
  uploadPpsAttachment: createAPIHandler(
    ([file, body = undefined, query = undefined]) => {
      const formData = new FormData();
      for (const key in body) formData.append(key, body[key]);
      formData.append("file", file);
      return [
        `/n/api/public/pps-attachments`,
        { method: "POST", query, body: formData }
      ];
    }
  ),
};
export { _PpsAttachmentsAPI as PpsAttachmentsAPI };
const _RegisterAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/register.js").createRegisterOrder>}  */
  createRegisterOrder: createAPIHandler(
    ([eventId, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(eventId)}/register`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/register.js").payRegisterOrder>}  */
  payRegisterOrder: createAPIHandler(
    ([event_id, order_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/register/${encodeURIComponent(order_id)}/pay`,
      { method: "POST", body, query }
    ]
  ),
};
export { _RegisterAPI as RegisterAPI };
const _RegistrationsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/registrations.js").getRegistration>}  */
  getRegistration: createAPIHandler(
    ([unique_id, query = undefined]) => [
      `/n/api/public/registrations/${encodeURIComponent(unique_id)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/registrations.js").getRegistrationByBibNumber>}  */
  getRegistrationByBibNumber: createAPIHandler(
    ([event_id, organization_id, bib_number_id, query = undefined]) => [
      `/n/api/public/registrations/${encodeURIComponent(event_id)}/${encodeURIComponent(organization_id)}/${encodeURIComponent(bib_number_id)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/registrations.js").transferRegistrationByBibNumber>}  */
  transferRegistrationByBibNumber: createAPIHandler(
    ([event_id, organization_id, bib_number_id, body = {}, query = undefined]) => [
      `/n/api/public/registrations/${encodeURIComponent(event_id)}/${encodeURIComponent(organization_id)}/${encodeURIComponent(bib_number_id)}`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {DownloadAPI<import("../../../../backend/api/public/registrations.js").getRegistrationQr>}  */
  getRegistrationQr: async function(unique_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/registrations/${encodeURIComponent(unique_id)}/qr`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `qr`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
  /** @type {FetchAPI<import("../../../../backend/api/public/registrations.js").invalidateRegistration>}  */
  invalidateRegistration: createAPIHandler(
    ([unique_id, body = {}, query = undefined]) => [
      `/n/api/public/registrations/${encodeURIComponent(unique_id)}/invalidate`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/registrations.js").getRegisterOrder>}  */
  getRegisterOrder: createAPIHandler(
    ([order_id, unique_id, query = undefined]) => [
      `/n/api/public/registrations/register-orders/${encodeURIComponent(order_id)}/${encodeURIComponent(unique_id)}`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/registrations.js").createRegistrationRecovery>}  */
  createRegistrationRecovery: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/registrations/registration-recovery`,
      { method: "POST", body, query }
    ]
  ),
  /** @type {DownloadAPI<import("../../../../backend/api/public/registrations.js").downloadTicket>}  */
  downloadTicket: async function(unique_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/registrations/${encodeURIComponent(unique_id)}/download-ticket`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `download-ticket`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
  /** @type {DownloadAPI<import("../../../../backend/api/public/registrations.js").downloadPaymentReceipt>}  */
  downloadPaymentReceipt: async function(order_id, unique_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/registrations/${encodeURIComponent(order_id)}/${encodeURIComponent(unique_id)}/download-payment-receipt`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `download-payment-receipt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
  /** @type {DownloadAPI<import("../../../../backend/api/public/registrations.js").downloadOption>}  */
  downloadOption: async function(order_id, option_id, query = undefined) {
    const response = await useOFetchRaw(`/n/api/public/registrations/${encodeURIComponent(order_id)}/download-option/${encodeURIComponent(option_id)}`, { responseType: "blob", query });
    const href = URL.createObjectURL(response["_data"]);
    const a = document.createElement("a");
    a.href = href;
    a.download = ((response["headers"].get("content-disposition") || "").match(/filename="?(.+)"?/) || [])[1] || `${encodeURIComponent(option_id)}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
    return;
  },
};
export { _RegistrationsAPI as RegistrationsAPI };
const _SettingsAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/settings.js").getSettings>}  */
  getSettings: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/settings`,
      { method: "GET", query }
    ]
  ),
};
export { _SettingsAPI as SettingsAPI };
const _SmtpAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/smtp.js").handleSMTPWebhooks>}  */
  handleSMTPWebhooks: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/smtp/webhooks`,
      { method: "POST", body, query }
    ]
  ),
};
export { _SmtpAPI as SmtpAPI };
const _UsersAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/users.js").getUser>}  */
  getUser: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/users/search`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/users.js").getEmailPreferences>}  */
  getEmailPreferences: createAPIHandler(
    ([query = undefined]) => [
      `/n/api/public/users/email-preferences`,
      { method: "GET", query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/users.js").updateEmailPreferences>}  */
  updateEmailPreferences: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/users/email-preferences`,
      { method: "PATCH", body, query }
    ]
  ),
  /** @type {FetchAPI<import("../../../../backend/api/public/users.js").createContactSupport>}  */
  createContactSupport: createAPIHandler(
    ([body = {}, query = undefined]) => [
      `/n/api/public/users/contact-support`,
      { method: "POST", body, query }
    ]
  ),
};
export { _UsersAPI as UsersAPI };
const _VisitAPI = {
  /** @type {FetchAPI<import("../../../../backend/api/public/visit.js").visit>}  */
  visit: createAPIHandler(
    ([event_id, form, last_step, visitor_id, body = {}, query = undefined]) => [
      `/n/api/public/events/${encodeURIComponent(event_id)}/visit/${encodeURIComponent(form)}/${encodeURIComponent(last_step)}/${encodeURIComponent(visitor_id)}`,
      { method: "POST", body, query }
    ]
  ),
};
export { _VisitAPI as VisitAPI };
